module.exports = __webpack_public_path__ + "img/1557614064141672449.7c1bae7b.png";